import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllInsurersAPI, getSingleInsurersAPI } from "./insurers.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

type IInsurersServiceProps = Omit<IGetAllServiceProps, "stage_id">;

const useAllInsurersService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: IInsurersServiceProps) => {
  const [searchInsurersQuery, setSearchInsurersQuery] = useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchInsurersQuery);
  const allInsurersService = useQuery({
    queryKey: [...CACHE_KEYS.INSURERS, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllInsurersAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchInsurersQuery, setSearchInsurersQuery },
    services: { allInsurersService },
  };
};

const useSingleInsurersService = ({
  singleInsurersId,
  enableQuery = true,
}: {
  singleInsurersId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.INSURERS, singleInsurersId],
    queryFn: () => getSingleInsurersAPI(singleInsurersId),
    enabled: !!singleInsurersId && enableQuery,
  });
};

export { useAllInsurersService, useSingleInsurersService };
